import { render, staticRenderFns } from "./section-performance-create.vue?vue&type=template&id=65fb5c13"
import script from "./section-performance-create.vue?vue&type=script&lang=js"
export * from "./section-performance-create.vue?vue&type=script&lang=js"
import style0 from "./section-performance-create.vue?vue&type=style&index=0&id=65fb5c13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports